// extracted by mini-css-extract-plugin
module.exports = {"TopArea":"TopArea_TopArea__ZOXCJ","Uploading":"TopArea_Uploading__Q9OZ7"};